<div class="row">
  <div class="col text-center">
    <h1 translate>DOCUMENTS</h1>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead class="table-light">
          <tr>
            <th scope="col" translate>NAME</th>
            <th scope="col" translate>SIZE</th>
            <th scope="col" translate>UPLOADED_BY</th>
            <th scope="col" translate>DATE</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let document of documentsList">
            <th scope="row">
              <a class="text-primary" [href]="getDocumentUrl(document.id)" target="_blank">{{ document.filename }}</a>
            </th>
            <td>{{ formatBytes(document.length, 0) }}</td>
            <td>{{ document.metaData.user }}</td>
            <td>{{ dateUtilService.parseDate(document.uploadDate) | date: 'yyyy-MM-dd H:mm:ss' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
